// extracted by mini-css-extract-plugin
export default {"WelcomeView":"WelcomeView_WelcomeView__3xmJG"};